// extracted by mini-css-extract-plugin
export default {"buttonStyles":"buttoncomponent_buttonStyles__mq5oO"};